<template>
    <div>
        <div id="paypal-button"></div>
        <p v-if="errors.paypal_token" class="text-red-600 text-sm">
            PayPal is currently unavailable.
        </p>
        <p
            v-if="!errors.paypal_token && paypalError"
            class="text-red-600 text-sm"
        >
            PayPal was blocked by your pop-up blocker. Please allow pop-ups to
            use this option.
        </p>
    </div>
</template>

<script setup lang="ts">
import { inject, onMounted, ref, watch } from "vue";
import type { AppEmitter } from "../../emitter";
import { usePaypal } from "../../functions/usePaypal";
import { useMoney } from "../../functions/useMoney";

const props = defineProps<{
    amount?: number;
    token?: string;
    errors?: any;
}>();

const emitter = inject<AppEmitter>("mitt")!;

const { generatePaypalToken, initiatePaypalCheckout, paypalError } =
    usePaypal();
const { dollars } = useMoney();
const enabled = ref(true);

generatePaypalToken();

onMounted(() => {
    emitter.on("paypalPopupOpen", (isOpen) => {
        paypalError.value = false;
        enabled.value = !isOpen;
    });
    emitter.on("paypalCheckoutError", () => {
        paypalError.value = true;
        enabled.value = true;
    });

    // FIXME(4f): `amount` and `token` are optional props, but the parent (Cart.vue)
    // always binds concrete values, so this path only runs once they exist. The
    // extra `amount === undefined` guard satisfies the `dollars(cents: number)` and
    // `initiatePaypalCheckout(token: string, …)` signatures while preserving the
    // existing runtime behavior. Note: the original guard tests the local watch
    // `token`, not `props.token` — preserved here by passing the narrowed `token`.
    watch(
        () => props.token,
        (token) => {
            if (token && enabled && !props.errors.paypal_token) {
                if (props.amount === undefined) {
                    return;
                }

                initiatePaypalCheckout(token, dollars(props.amount));
            }
        },
    );
});
</script>

<style>
iframe {
    z-index: 10 !important;
}
</style>
